<template>
  <div class="page-container">
    <PageHeader />
    <main class="page-main" :class="{ 'is-board': isBoardPage }">
      <router-view :key="$route.fullPath" />
    </main>
  </div>
</template>

<script>
import PageHeader from "@/components/dataheader/PageHeader.vue";

export default {
  name: "layout",
  components: {
    PageHeader,
  },
  computed: {
    isBoardPage() {
      return this.$route.path.startsWith("/board");
    },
  },
};
</script>
